import { useRouter } from 'expo-router';
import { YStack } from 'tamagui';

import UpcomingBookingBanner from '@/components/UpcomingBookingBanner';
import type { MinimalBooking } from '@/src/api/bookingsApi';
import { formatDateTime } from '@/src/utils/dateFormatter';

export default function UpcomingBookingsSection({
  bookings,
  variant = 'light',
}: {
  bookings: MinimalBooking[];
  variant?: 'light' | 'dark';
}) {
  const router = useRouter();

  if (bookings.length === 0) return null;

  return (
    <YStack gap="$space.md">
      {bookings.map((booking) => (
        <YStack
          key={booking.id}
          cursor="pointer"
          pressStyle={{ opacity: 0.6 }}
          onPress={() => router.push(`/bookings/${booking.id}`)}
        >
          <UpcomingBookingBanner
            image={booking.event.images.at(0)?.url ?? ''}
            title={booking.event.title}
            ticketSlotDisplayLine={formatDateTime(booking.slot.startDatetime)}
            variant={variant}
          />
        </YStack>
      ))}
    </YStack>
  );
}
